module.exports = __webpack_public_path__ + "img/GE.67118910.png";